document.addEventListener("DOMContentLoaded", () => {
    let storedVariants = JSON.parse(localStorage.getItem("wishListVariants"))
    let variantArray = Wishlist.variantArray
    const customerId = Wishlist.customerId

    console.log(customerId)
    console.log(variantArray)

    if (storedVariants) {
        const storedVariantIds = storedVariants.map(variant => Number.parseInt(variant, 10));

        storedVariantIds.forEach(variantId => {
            if (!variantArray.includes(variantId)) {
                variantArray.push(variantId);
            }
        });

        variantArray = variantArray.filter(variantId => storedVariantIds.includes(variantId));

        console.log("Synced Variant Array:", variantArray);
    } else {
        console.log("No stored variants found.");
    }

    localStorage.setItem("wishListVariants", JSON.stringify(variantArray));


    const postRequest = async (payload) => {
        try {
            const response = await fetch("https://hook.eu1.make.com/digfko3mrfjmlukev2oe1dxi6exdhvys", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            const data = await response.text();
            console.log("Payload: ", JSON.stringify(payload))
            console.log("Response: ", data)

        } catch (error) {
            console.error("Error:", error);
        }
    }

    window.wishlistSetActiveStates = () => {
        document.querySelectorAll("[li-element='wishlist-button']").forEach(button => {
            const variantId = Number.parseInt(button.dataset.variantId, 10)

            if (variantArray.includes(variantId)) {
                button.classList.add("is-active")
            } else {
                button.classList.remove("is-active")
            }
        })
    }

    const setVariant = (variantId) => {
        const variantIndex = variantArray.indexOf(variantId);
        if (variantIndex !== -1) {
            variantArray.splice(variantIndex, 1);
        } else {
            variantArray.push(variantId)
        }

        localStorage.setItem("wishListVariants", JSON.stringify(variantArray));

        console.log("Variant Array: ", variantArray)

        wishlistSetActiveStates()


        if (customerId !== "") {
            let requestVariantArray = []

            variantArray.forEach(variant => {
                requestVariant = `gid://shopify/ProductVariant/${variant}`
                requestVariantArray.push(requestVariant)
            })

            console.log("Request Array: ", requestVariantArray)

            postRequest({
                variants: requestVariantArray,
                customerId: customerId
            })

            requestVariantArray = []
        }
    }

    const handleWishlistClick = (event) => {
        const button = event.currentTarget;
        const variantId = Number.parseInt(button.dataset.variantId, 10);
        if (!variantId) return;

        setVariant(variantId);
    };

    window.wishlistInitButtons = () => {
        document.querySelectorAll("[li-element='wishlist-button']").forEach(button => {
            button.removeEventListener("click", handleWishlistClick);
            button.addEventListener("click", handleWishlistClick);
        })
    }

    console.log("Is account page?", Wishlist.isAccountPage)

    if (customerId !== "" && Wishlist.isAccountPage == true) {
        let requestVariantArray = []

        variantArray.forEach(variant => {
            requestVariant = `gid://shopify/ProductVariant/${variant}`
            requestVariantArray.push(requestVariant)
        })

        console.log("Request Array: ", requestVariantArray)

        postRequest({
            variants: requestVariantArray,
            customerId: customerId
        })

        requestVariantArray = []
    }

    window.wishlistSetActiveStates()
    window.wishlistInitButtons()
})

document.addEventListener("liquify:sections-rendered", () => {
    setTimeout(() => {
        wishlistSetActiveStates()
        wishlistInitButtons()
    }, 0)
})